import AgreeToTcField from './AgreeToTcField.component';

export default AgreeToTcField;
